<p class="mb-5 text-sm text-[#737373]">
  When submitting the form, you agree that we may use your provided data to send you emails on our updates.For
  additional info please refer to our
  <a target="_blank" href="https://digitaloriginal.app/privacy-policy" class="cursor-pointer underline"
    >Privacy Policy</a
  >.
</p>
